<template>
  <div class="depp-list" sticky-container>
    <div class="page-container dep-list-header">
      <div class="dep-list-header__head">
        <div class="dep-list-header__label">
          {{ $t('labels.filters_and_actions') }}
        </div>
        <div class="dep-list-header__head-buttons">
          <router-link v-if="admin" :to="{ name: 'orgCreate'}" class="el-button el-button--medium">
            <i class="el-icon-plus"></i>
            <span>{{ $t('orgs.add_subdivision') }}</span>
          </router-link>
          <!-- <el-button v-if="!editMode" icon="el-icon-edit" @click="editMode = true">{{ $t('labels.edit') }}</el-button> -->
        </div>
      </div>
      <div class="dep-list-filters">
        <div class="dep-list-filters__first-line">
          <div class="dep-list-filters__filter">
            <div class="dep-list-filters__filter-label">
              {{ $t('labels.organization_structure') }}
            </div>

            <tree-select @checked="onOrgChecked"
                         :placeholder="$t('labels.organizations')"
                         :data="departmentsList"
                         nodeKey="id"
                         :props="{label: 'name', children: 'children'}"
                         multiselect
                         ref="departmenList">

            </tree-select>
          </div>
          <div class="dep-list-filters__filter">
            <div class="dep-list-filters__filter-label">
              {{ $t('labels.search_by_name') }}
            </div>
            <el-input :placeholder="$t('orgs.search_org')" v-model="search"></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="dep-list-pagination">
      <div class="dep-list-pagination__info">
        <div class="dep-list-pagination__info-count">
          {{ $t('orgs.total_subdivisions') }}: <span>{{filteredDepartmentsCount}}</span>
        </div>
        <div class="dep-list-pagination__info-summary" v-if="false">
          {{ $t('orgs.total_actual_subdivisions') }}: <span>{{departmentsCount}}</span>
        </div>
      </div>
    </div>
    <div v-if="editMode" class="dep-list-edit-panel" v-sticky sticky-offset="stickyOffset" sticky-side="top">
      <div class="dep-list-edit-panel__edit-buttons">
        <router-link :to="{ name: 'departmentCreate'}" class="el-button el-button--text">
            <i class="el-icon-plus"></i>
            <span>{{ $t('orgs.add_subdivision') }}</span>
        </router-link>
      </div>

      <div class="dep-list-edit-panel__save-buttons">
        <el-button @click="saveEdit" type="primary">{{ $t('labels.save') }}</el-button>
        <el-button @click="cancelEdit">{{ $t('labels.cancel') }}</el-button>
      </div>

    </div>
    <div class="dep-list-container">
      <orgs-tree v-if="depList"
                :depList="filteredList"
                :adminMode="admin"
                @parentChanged="parentChanged"
                @updateData="updateData"></orgs-tree>
    </div>
  </div>
</template>
<script>
import orgsTree from './OrgsTree/OrgsTree.vue'
// import getDepartmentList from 'src/services/departmentList'
// import org from 'src/api/org'
import TreeSelect from 'src/components/TreeSelect/TreeSelect';
import {USER_ROLE_ADMIN} from '@/constants'

export default {
  components: {
    TreeSelect,
    orgsTree
  },
  data () {
    return {
      stickyOffset: {top: 75},
      intersectionOptions: {
        root: null,
        rootMargin: '10px 0px 0px 0px',
        thresholds: [0]
      },
      depList: [],
      departmensList: [],
      tempDepList: [],
      editMode: false,
      query: {
        status: []
      },
      orgChanges: [],
      search: '',
      filters: {
        orgIds: []
      },
      departmentsList: []
    }
  },
  computed: {
    admin () {
      if (this.$store.state.user.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_ADMIN)
      }
      return false
    },
    // departmensList: self => self.$store.state.users.departments,
    perms: self => {
      return {
        // orgCreate: self.$store.state.users.user.checkPerm('PERM_ORG_CREATE')
      }
    },
    departmentsCount () {
      let count = 0
      if (this.depList) {
        count = this.getChildCount(this.depList)
      }
      return count
    },
    filteredDepartmentsCount () {
      let count = 0
      if (this.filteredList) {
        count = this.getChildCount(this.filteredList)
      }
      return count
    },
    filteredList () {
      let list = JSON.parse(JSON.stringify(this.depList));
      if (this.search || this.filters.orgIds.length > 0) {
        this.filterChilds(list)
      }
      return list
    }
  },
  methods: {
    async getDepTree () {
      try {
        let list = await this.$store.dispatch('orgs/loadRawOrgList')
        let tree = this.$store.getters['orgs/getRawTree'](list)
        this.departmentsList = tree;
      } catch (error) {
        console.error('LOG: getDepList -> error', error)
      }
    },
    onOrgChecked (data, checked) {
      this.filters.orgIds = checked.checkedKeys
    },
    filterChilds (list) {
      let search = !!this.search
      let filter = this.filters.orgIds.length > 0
      let test = new RegExp(this.search, 'i')
      let matchInList = false
      for (let index = list.length - 1; index >= 0; index--) {
        let item = list[index]

        let idMatch = filter && this.filters.orgIds.indexOf(item.id) !== -1
        let match = search && test.test(item.name)

        let childMatch = false
        if (item.children) {
          childMatch = this.filterChilds(item.children, this.search)
        }
        let find = childMatch || ((!search || match) && (!filter || idMatch))
        if (!find) {
          list.splice(index, 1)
        }
        matchInList = matchInList || find
      }
      return matchInList
    },
    getChildCount (items) {
      let count = items.length
      for (let item of items) {
        if (item.children) {
          count += this.getChildCount(item.children)
        }
      }
      return count
    },
    async getOrgList () {
      let list = await this.$store.dispatch('orgs/loadRawOrgList')
      let tree = this.$store.getters['orgs/getRawTree'](list)
      this.depList = tree;
      console.log('LOG: getOrgList -> tree', tree)
    },
    updateData () {
      this.depList = null
      this.tempDepList = null
      this.getOrgList()
    },
    saveEdit () {
      /* if (this.orgChanges.length > 0) {
        for (let [index, change] of this.orgChanges.entries()) {
          org.setParent(change.child, change.parent).then(data => {
            if (index === this.orgChanges.length - 1) {
              this.cancelEdit()
              this.$notify({
                // @ts-ignore
                title: this.$t('labels.success'),
                message: this.$t('orgs.structure_changed'),
                type: 'success',
                offset: 75
              })
            }
          })
        }
      } */
    },
    cancelEdit () {
      this.getOrgList()
      this.editMode = false;
      this.orgChanges = []
    },
    parentChanged (child, parent) {
      let change = {
        child: child.data.id,
        parent: 'org:' + parent.data.id
      }

      for (let [index, item] of this.orgChanges.entries()) {
        if (change.child === item.child) {
          this.orgChanges.splice(index, 1);
        }
      }
      this.orgChanges.push(change)
    }
  },

  async mounted () {
    await this.getOrgList()
    await this.getDepTree()
    /* this.$store.dispatch('users/loadDepartments', true)
    if (window.innerWidth <= 1440) {
      this.stickyOffset.top = 0;
    } */
  }
}
</script>
<style lang="scss">
@import '../../assets/sass/core';
.dep-list-header {
  margin-bottom: 28px;

  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 25px 25px 25px;
    margin: 0 -25px;
    border-bottom: 1px solid $light-border-color;
    @include respond-to(phone){
      display: block;
    }
  }

  &__label {
    font-size: 20px;
    font-weight: 700;
    color: #000;
    @media (max-width: $screen-lg){
      margin-bottom: 15px;
    }
  }

  &__head-buttons {
    .el-button {
      @media (max-width: $screen-sm){
        display: block;
        margin-bottom: 15px;
      }

      & + .el-button {
        @media (max-width: $screen-sm){
          margin-left: 0;
        }
      }
    }
  }
}

.dep-list-filters {
  padding-top: 25px;

  &__first-line {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 15px;
    margin-bottom: 25px;

    @media (max-width: $screen-md){
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: $screen-sm){
      grid-template-columns: repeat(1, 1fr);
    }
  }

  &__second-line {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 15px;
    max-width: 550px;

    @media (max-width: $screen-sm){
      grid-template-columns: repeat(1, 1fr);
    }
  }

  &__filter {
    .el-select {
      width: 100%;
    }
  }

  &__filter-label {
    margin-bottom: 5px;
    font-size: 14px;
    color: #333333;
  }
}

.dep-list-pagination {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  align-items: flex-end;

  @media (max-width: $screen-sm){
    display: block;
  }

  &__info {
    @media (max-width: $screen-sm){
      margin-bottom: 10px;
    }
  }

  &__info-count {
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 700;
    color: #000;
  }

  &__info-summary {
    font-size: 12px;
    color: #909399;
  }
}


.dep-list-edit-panel {
  padding: 10px 30px;
  margin-bottom: 15px;
  background: #fff;
  box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.05);
  border-radius: $global-radius;
  display: flex;
  justify-content: space-between;
  align-content: center;

  &__edit-buttons {
    .el-button {
      color: $secondary-font-color;

      &:hover {
        color: #2F80ED;
      }
    }
  }
}
@media screen and (max-width:425px){
  .dep-list-edit-panel{flex-direction: column;}
}

.dep-list-container {
  overflow-x: auto;
  background: #fff;
  border-radius: $global-radius;
}
</style>